import ButtonSimple from '../ui/buttons/ButtonSimple';
import { StarBurst } from '../display/ui/StarBurst';
import { MODE_SEEK } from '../constants/AppConstants';
import { getGA } from 'analytics/GoogleAnalytics';

export default class Character extends Phaser.Group {
  constructor(game, slotRef, charData, scale) {
    super(game);

    this.slotRef = slotRef; // reference to hiding place slot
    this.charData = charData;
    this.isCharFound = false;
    this.slotScale = scale;

    this.clothSlotRef = null;
    this.clothId = -1;
    this.clothData = this.game.controller.gameData.clothes.find(
      (d) => d.character === this.charData.id
    );

    //
    this.x = charData.offset.x;
    this.y = charData.offset.y;

    //
    this.onFindChar = new Phaser.Signal();
    this.onRemoveChar = new Phaser.Signal();
    this.onTapClothingEdit = new Phaser.Signal();
    this.onTapClothingCheck = new Phaser.Signal();
    this.onWearClothes = new Phaser.Signal();

    //
    this.hudSlotRef = null; // reference to characters slot in hud
    this.timeToWiggle = Phaser.Math.random(5, 7);

    this.createCharacter();
  }

  /* eslint-disable max-statements */
  createCharacter() {
    this.character = this.game.make.spine(0, 0, this.charData.id, true);
    this.character.anchor.set(0.5, 1);
    this.addChild(this.character);
    // scale
    let dir = 1;
    if (this.charData.direction === 'right') {
      dir = -1;
    }
    this.character.skeleton.getRootBone().scaleX = 0.4 * dir * this.slotScale;
    this.character.skeleton.getRootBone().scaleY = 0.4 * this.slotScale;
    this.character.setSkinByName(this.clothData.skin_name);

    // twins
    if (this.charData.id === 'twins') {
      this.character2 = this.game.make.spine(dir * 50 * this.slotScale, 0, 'mary', true);
      this.character2.anchor.set(0.5, 1);
      this.addChildAt(this.character2, 0);
      // scale
      this.character2.skeleton.getRootBone().scaleX = 0.4 * dir * this.slotScale;
      this.character2.skeleton.getRootBone().scaleY = 0.4 * this.slotScale;
      this.character2.setSkinByName(this.clothData.skin_name);
    }

    //
    this.mixAnimations();

    //
    this.playAnim('hiding');

    //
    this.updateTransform();
    this.update();

    // make it interactive
    this.startX = 0;
    this.startY = 0;
    this.isDown = false;

    this.button = this.game.make.button(0, 0, 'slot_marker');
    this.button.width = this.character.width * 0.5 * this.slotScale;
    this.button.height = this.character.height * 0.4 * this.slotScale;
    if (this.charData.id === 'ari') {
      // exception for Ari
      this.button.width = this.character.width * 0.7 * this.slotScale;
      this.button.x -= dir * this.slotScale * 50;
    }
    this.button.alpha = 0;
    this.button.anchor.set(0.5, 1);
    this.addChild(this.button);
    this.button.inputEnabled = true;
    this.button.events.onInputDown.add(this.handleInputDown, this);
    this.button.events.onInputUp.add(this.handleInputUp, this);
    if (this.game.controller.gameMode === MODE_SEEK) {
      this.button.input.useHandCursor = false;
    }

    // add dress up button if available
    this.addDressUpButtons();
  }
  /* eslint-enable */

  mixAnimations() {
    this.character.setMixByName('wiggle', 'hiding', 0.2);
    this.character.setMixByName('hiding', 'wiggle', 0.2);
    this.character.setMixByName('hiding', 'peer out', 0.2);
    this.character.setMixByName('peer out', 'idle', 0.2);
    this.character.setMixByName('hiding', 'reveal', 0.2);

    if (this.character2) {
      this.character2.setMixByName('wiggle', 'hiding', 0.2);
      this.character2.setMixByName('hiding', 'wiggle', 0.2);
      this.character2.setMixByName('hiding', 'peer out', 0.2);
      this.character2.setMixByName('peer out', 'idle', 0.2);
      this.character2.setMixByName('hiding', 'reveal', 0.2);
    }
  }

  //
  addDressUpButtons() {
    if (this.game.controller.levelData.dress_up) {
      const x0 = this.slotRef.x + this.x;
      const y0 = this.slotRef.y + this.y - this.height + this.character.y - 50;
      const y1 = Math.min(660, this.slotRef.y + this.y + 70);

      // edit button
      this.btnClothingEdit = new ButtonSimple({
        game: this.game,
        up: 'btn_clothing_edit',
        over: 'btn_clothing_edit',
      });
      this.btnClothingEdit.x = x0;
      this.btnClothingEdit.y = y0;
      this.btnClothingEdit.onInputDown.add(this.handleClothingEditDown, this);

      // check button
      this.btnClothingCheck = new ButtonSimple({
        game: this.game,
        up: 'btn_clothing_check',
        over: 'btn_clothing_check',
      });
      this.btnClothingCheck.x = x0;
      this.btnClothingCheck.y = y0;
      if (y0 < 320) {
        // place button under character
        this.btnClothingCheck.y = y1;
        const frame = 'btn_clothing_check_up';
        this.btnClothingCheck.setFrames(frame, frame, frame, frame);
      }
      this.btnClothingCheck.onInputDown.add(this.handleClothingCheckDown, this);
      this.btnClothingCheck.visible = false;

      //
      const location = this.game.state.getCurrentState().location;
      if (this.slotRef.data.layer === 'bg') {
        // add to back
        location.midUI.addChild(this.btnClothingEdit);
        location.midUI.addChild(this.btnClothingCheck);
      } else {
        // add to front
        location.forUI.addChild(this.btnClothingEdit);
        location.forUI.addChild(this.btnClothingCheck);
      }
    }
  }

  handleClothingEditDown() {
    this.slotRef.getCharacterToFront();
    this.playAnim('idle');

    this.btnClothingEdit.visible = false;
    this.btnClothingCheck.visible = true;

    this.game.state.getCurrentState().openDressUp(this, this.charData.id, this.clothId);

    this.onTapClothingEdit.dispatch();

    // tracking
    getGA().track({ action: 'DressUpModeSelected' });
  }

  handleClothingCheckDown() {
    this.slotRef.sendCharacterBack();
    this.playAnim('hiding');

    this.btnClothingEdit.visible = true;
    this.btnClothingCheck.visible = false;

    this.game.state.getCurrentState().hideDressUp();

    this.onTapClothingCheck.dispatch();
  }

  showDressUpButtons() {
    if (this.btnClothingEdit) {
      this.btnClothingEdit.visible = true;
      this.btnClothingCheck.visible = false;
    }
  }

  hideDressUpButtons() {
    if (this.btnClothingEdit) {
      this.btnClothingEdit.visible = false;
      this.btnClothingCheck.visible = false;
    }
  }

  //
  addCharacter() {
    this.alpha = 1;
  }

  get height() {
    const heights = {
      ari: 630,
      elinor: 630,
      koa: 630,
      mary: 630,
      olive: 630,
      tito: 630,
      twins: 630,
    };
    const rb = this.character.skeleton.getRootBone();
    // return rb.skeleton.data.height * rb.scaleY;
    return heights[this.charData.id] * rb.scaleY;
  }

  playAnim(anim, loop = true) {
    if (this.currentAnim !== anim) {
      this.currentAnim = anim;
      this.character.setAnimationByName(0, anim, loop);
      if (this.character2) {
        this.character2.setAnimationByName(0, anim, loop);
      }
    }
  }

  handleInputDown(target, pointer) {
    if (this.game.controller.gameMode === MODE_SEEK) {
      // 'seek' game mode
      this.findMe();
    } else {
      // 'hide' game mode
      this.pointer = pointer;
      this.isDown = true;
      this.startX = pointer.x;
      this.startY = pointer.y;
    }
  }

  handleInputUp() {
    if (this.isDown) {
      this.pickUp();
    }
  }

  pickUp() {
    this.slotRef.isEmpty = true;

    //
    this.game.state
      .getCurrentState()
      .startDragCharacter(
        this.charData.id,
        this.hudSlotRef,
        this.clothSlotRef,
        this.clothId,
        this.worldPosition.x,
        this.worldPosition.y - this.height * this.scale.y * 0.5,
        this.pointer,
        true
      );

    //
    this.game.sounds.playSFX('remove_pop', { spriteID: 'sfx_gameplay', volume: 0.3 });

    //
    this.slotRef.removeCharacter();
  }

  findMe() {
    if (!this.isCharFound) {
      // dispatch event
      this.onFindChar.dispatch(this.charData.id);
      this.lock();
    }
  }

  lock(withClothing = true) {
    this.button.input.enabled = false;
    this.button.visible = false;

    if (this.btnClothingEdit && withClothing) {
      this.btnClothingEdit.input.enabled = false;
      this.btnClothingCheck.input.enabled = false;
    }
  }

  unlock() {
    if (!this.isCharFound) {
      this.button.input.enabled = true;
      this.button.visible = true;
    }

    if (this.btnClothingEdit) {
      this.btnClothingEdit.input.enabled = true;
      this.btnClothingCheck.input.enabled = true;
    }
  }

  unlockCheckBtn() {
    if (this.btnClothingEdit) {
      this.btnClothingEdit.input.enabled = true;
      this.btnClothingCheck.input.enabled = true;
    }
  }

  removeControls() {
    this.button.inputEnabled = false;
    this.button.events.onInputDown.remove(this.handleInputDown, this);
  }

  reveal() {
    this.isCharFound = true;
    this.playAnim('peer out');

    //
    this.game.add.tween(this.character).to({ alpha: 0 }, 500, null, true, 1500);
    if (this.character2) {
      this.game.add.tween(this.character2).to({ alpha: 0 }, 500, null, true, 1500);
    }
    if (this.outfit) {
      this.game.add.tween(this.outfit).to({ alpha: 0 }, 500, null, true, 1500);
    }

    // add star particles
    const stars = new StarBurst(this.game, {
      x: 0,
      y: -this.height * 0.6,
    });
    this.addChild(stars);

    //
    this.game.sounds.playSFX('found', { spriteID: 'sfx_gameplay', volume: 0.3 });
  }

  jumpUp() {
    if (this.slotRef.data.jump_up === 'up') {
      const dy = 100 * this.slotScale;
      this.game.add
        .tween(this.character)
        .to({ y: this.character.y - dy }, 300, Phaser.Easing.QuadraticOut, true);
      if (this.character2) {
        this.game.add
          .tween(this.character2)
          .to({ y: this.character2.y - dy }, 300, Phaser.Easing.QuadraticOut, true);
      }
    } else if (this.slotRef.data.jump_up === 'left') {
      // this.game.add.tween(this.character).to({ angle: -10 }, 300, Phaser.Easing.QuadraticOut, true);
    } else if (this.slotRef.data.jump_up === 'right') {
      // this.game.add.tween(this.character).to({ angle: 10 }, 300, Phaser.Easing.QuadraticOut, true);
    }

    this.playAnim('reveal');
  }

  update() {
    super.update();

    // wiggle character
    if (!this.isCharFound && this.game.controller.gameMode === MODE_SEEK) {
      const levelRef = this.game.state.getCurrentState();
      if (levelRef.gameStarted) {
        if (this.worldPosition.x > 50 && this.worldPosition.x < this.game.width - 50) {
          const dt = Math.min(0.1, this.game.time.elapsedMS / 1000);
          this.timeToWiggle -= dt;
          if (this.timeToWiggle < 0 && levelRef.timeToWiggle < 0) {
            this.timeToWiggle = Phaser.Math.random(5.5, 7);
            levelRef.timeToWiggle = 5;
            this.wiggle();
          }
        } else {
          this.timeToWiggle = Phaser.Math.random(5.5, 7);
        }
      }
    }

    // start drag
    if (this.isDown) {
      const dx = Math.abs(this.pointer.x - this.startX);
      const dy = Math.abs(this.pointer.y - this.startY);
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist > 20) {
        this.pickUp();
      }
    }
  }

  wiggle() {
    // this.tween = this.game.add
    //   .tween(this.character)
    //   .to({ x: [-3, 3, -3, 3, 0] }, 500, Phaser.Easing.QuadraticOut, true);
    this.playAnim('wiggle', false);
    this.game.time.events.add(1000, this.onWiggleEnd, this);
    const sfx = Math.random() < 0.5 ? 'giggle' : 'rustle';
    this.game.sounds.playSFX(sfx, { spriteID: 'sfx_gameplay', volume: 0.5 });
  }

  onWiggleEnd() {
    if (this.currentAnim === 'wiggle') {
      this.playAnim('hiding');
    }
  }

  wearCloth(clothSlotRef, clothData) {
    // return old outfit
    if (this.clothId !== -1 && this.clothSlotRef) {
      this.clothSlotRef.resetOutfit();
    }

    this.clothSlotRef = clothSlotRef;
    if (clothData.wearable) {
      // set custom skin
      this.clothId = clothData.id;
      this.character.setSkinByName(clothData.skin_name);
      if (this.character2) {
        this.character2.setSkinByName(clothData.skin_name);
      }
    } else {
      // set default skin
      this.clothId = -1;
      this.character.setSkinByName(this.clothData.skin_name);
      if (this.character2) {
        this.character2.setSkinByName(this.clothData.skin_name);
      }
    }

    let rb = this.character.skeleton.getRootBone();
    let x0 = rb.scaleX;
    let y0 = rb.scaleY;
    this.character.setToSetupPose();
    rb.scaleX = x0;
    rb.scaleY = y0;
    if (this.character2) {
      rb = this.character2.skeleton.getRootBone();
      x0 = rb.scaleX;
      y0 = rb.scaleY;
      this.character2.setToSetupPose();
      rb.scaleX = x0;
      rb.scaleY = y0;
    }

    this.updateTransform();
    this.update();

    this.slotRef.updateRating();

    //
    this.onWearClothes.dispatch();
  }

  destroy() {
    if (this.btnClothingCheck) {
      this.btnClothingEdit.destroy();
      this.btnClothingCheck.destroy();
    }

    if (this.outfit) {
      this.outfit.destroy();
    }

    this.character.destroy();
    if (this.character2) {
      this.character2.destroy();
    }
    this.button.destroy();

    this.btnClothingEdit = null;
    this.btnClothingCheck = null;
    this.outfit = null;
    this.character = null;
    this.character2 = null;
    this.button = null;

    super.destroy();
  }
}
